module.exports = __webpack_public_path__ + "img/linkedin2.5d9d70e1.png";